<script>
    import Vue from "vue";

    export default {
        name: "SoftwareStack",
    };
</script>


<template>
    <plain-page class="software-stack">
        <h1>
            <Emoji name="toolbox" />
            Software Used in Lockbox
        </h1>

        <ul>
            <li>
                The user interface is written in <a href="https://vuejs.org/">Vue.js</a>, bootstrapped using Vue CLI.
            </li>
            <li>
                Icons from <a href="https://openmoji.org/">OpenMoji</a> and
                <a href="https://material.io/resources/icons/">material design</a>.
            </li>
            <li>
                Encryption code by <a href="https://cryptojs.gitbook.io/docs/">CryptoJS</a>.
            </li>

            <li>
                Raleway and Lato fonts served from <a href="https://fonts.google.com/">Google Fonts</a>.
            </li>
            <li>
                Data is stored in Google's <a href="https://firebase.google.com/docs/firestore">Cloud Firestore</a>,
                and the application is served using <a href="https://cloud.google.com/appengine">App Engine</a>.
            </li>
            <li>
                English dictionary words for passphrase validation snatched from
                <a href="https://github.com/dwyl/english-words">dwyl / english-words</a>.
            </li>
            <li>
                The domain is controlled with <a href="https://www.cloudflare.com/">cloudflare</a>, that also
                protects Lockbox from straight-out DDOS attacks.
            </li>
        </ul>

        <div class="backlink">
            <a href="/">
                Go to Lockbox
            </a>
        </div>

    </plain-page>
</template>


<style lang="scss">
    .software-stack {
        .backlink {
            text-align: center;
            margin-top: 3em;
        }

        ul {
            margin-top: 3em;
        }
        li {
            margin: 0;
            padding: 10px 0;
        }
    }
</style>

